import { render, staticRenderFns } from "./LogUpdateSP.vue?vue&type=template&id=2bd0d632&lang=true&"
import script from "./LogUpdateSP.vue?vue&type=script&lang=js&"
export * from "./LogUpdateSP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports